import type { Locale } from '@/stores/locale.store'
import ko from '@/messages/ko.json'
import en from '@/messages/en.json'

export type Messages = typeof ko

const messages: Record<Locale, Messages> = { ko, en }

export function getMessages(locale: Locale): Messages {
  return messages[locale] ?? messages.ko
}
